import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store"; // 导入store实例

import HomePage from "../views/Home.vue";
import LoginPage from "../views/Login.vue";
import BoostOrdersPage from "../views/boostOrders.vue";
import NewBoostPage from "../views/newBoost.vue";
import AddBoostPage from "../views/NewBoost/addBoost.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      return store.state.sessionid ? "/home" : "/login";
    },
  },
  {
    path: "/home",
    name: "Home",
    component: HomePage,
    meta: { requiresAuth: true,keepAlive: false }, // 需要认证的页面
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { requiresGuest: true,keepAlive: false }, // 防止已登录用户再次访问登录页
  },
  {
    path: "/boostOrders",
    name: "boostOrders",
    component: BoostOrdersPage,
    meta: { requiresAuth: true,keepAlive: false },
  },
  {
    path: "/newBoost",
    name: "newBoost",
    component: NewBoostPage,
    meta: { requiresAuth: true,keepAlive: true },
  },
  {
    path: "/addBoost",
    name: "addBoost",
    component: AddBoostPage,
    meta: { requiresAuth: true,keepAlive: false },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 导航守卫
router.beforeEach((to, from, next) => {
  console.log("State value:", store.state);
  const isAuthenticated = !!store.state.sessionid;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  }
  // 已登录用户访问登录页
  else if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (isAuthenticated) {
      next({ path: "/boostOrders" });
    } else {
      next();
    }
  }
  // 其他情况（如首页、不需要权限的路由）
  else {
    next();
  }
});

export default router;
